<template>
    <div>
      <b-row>
        <b-col>
          <h2 id="traffic" class="card-title mb-0">Praça [{{ $store.state.currentUnit.code }}] {{ $store.state.currentUnit.description  }} </h2>
        </b-col>
        <b-col sm="7" class="">
          <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
              <span style="width:10px"></span>
              <b-button type="button" @click="unselectUnit" variant="primary" class="float-right"><i class="icon-shuffle"></i></b-button>
          </b-button-toolbar>
          
          </b-col>
      </b-row>
      <b-row>
        <b-col>
        <h4>[{{ $store.state.currentUser.code }}] {{ $store.state.currentUser.name }}</h4>    
        </b-col>
      </b-row>
    </div>
</template>

<script>
export default {
  name: "ChangeControlHeaderComponent",
  props: {
  },
  data() {
    return {
    }
  },
  methods: {
     unselectUnit() {
      this.$store.commit('SET_CURRENT_UNIT', {} )
    },
  }   
};
</script>
